exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle[data-v-8ffd4ef0] {\n  font-size: 1.025rem;\n  margin: 0;\n  cursor: move;\n  color: #fff;\n  position: absolute;\n  left: 30px;\n  top: 14px;\n}\n", ""]);

// exports
